import { API_VERSION } from './define';
import { callFetch } from './response';
import { authAccessTokenHeader } from './settings';
const resource = 'event';

const EndPoint = {
    GetAvailableTimes: (scheduleEventId, startDate, endDate) =>
        `/${API_VERSION}/${resource}/${scheduleEventId}/schedule?startDate=${startDate}&endDate=${endDate}`,
    GetScheduleEvent: (scheduleEventId) => `/${API_VERSION}/${resource}/${scheduleEventId}`
};

export function getScheduleEvent(scheduleEventId, accessToken) {
    const uri = EndPoint.GetScheduleEvent(scheduleEventId);
    let settings = {
        method: 'GET',
        headers: { ...authAccessTokenHeader(accessToken) }
    };

    // return new Promise((resolve) => {
    //     resolve({ err: false, data: ACTIVITY });
    // });
    return callFetch(uri, settings);
}

export function getAvailableTimes(scheduleEventId, startdate, enddate, accessToken) {
    const uri = EndPoint.GetAvailableTimes(scheduleEventId, startdate, enddate);
    let settings = {
        method: 'GET',
        headers: { ...authAccessTokenHeader(accessToken) }
    };

    // return new Promise((resolve) => {
    //     resolve({ err: false, data: ACTIVITY });
    // });
    return callFetch(uri, settings);
}
